import { render, staticRenderFns } from "./MidiaVerticalView.vue?vue&type=template&id=0aa1ab52&scoped=true"
import script from "./MidiaVerticalView.vue?vue&type=script&lang=js"
export * from "./MidiaVerticalView.vue?vue&type=script&lang=js"
import style0 from "./MidiaVerticalView.vue?vue&type=style&index=0&id=0aa1ab52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1ab52",
  null
  
)

export default component.exports